import { Paper, Typography } from '@mui/material';
import React from 'react';
import { getVisualTimer } from '../../sports/rules.js';
import QuillEditor from './QuillEditor.js';
import PushPinIcon from '@mui/icons-material/PushPin';

const RecapArticle = ({ article, match }) => {
  const { title, content, imageUrl, timer, period, isPin, displayDate, creation } = article;

  return (
    <div>
      <Typography variant="h5">{title}</Typography>

      {/* Editor Content */}
      <Paper
          sx={{
            padding: 2,
            marginBottom: 2,
            backgroundColor: '#f9f9f9',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            borderRadius: '15px',
          }}
        >
          <QuillEditor
            theme="snow"
            content={content}
            readOnly={true}
            modules={{ toolbar: null }}
          />
      </Paper>

      {/* Image */}
      {imageUrl && <img src={imageUrl} width={100} alt="article visual" />}

      {/* Match minute if applicable */}
      {match.idMatch && (
        <Typography>
          Minute : {getVisualTimer(period, timer / 60, match.discipline)}
        </Typography>
      )}

      {/* Display if pinned */}
      {isPin && (
        <Typography variant="body1" color="primary" sx={{ marginTop: 1 }}>
            <PushPinIcon fontSize="small" style={{ marginRight: 4, color: 'black' }} />
          Cet article est épinglé
        </Typography>
      )}

      {/* Display Date */}
      {displayDate ? (
        <Typography variant="body2" sx={{ marginTop: 1 }}>
          Publié le : {new Date(displayDate).toLocaleDateString()} à{' '}
          {new Date(displayDate).toLocaleTimeString()}
        </Typography>
      )
      :
      (
        <Typography variant="body2" sx={{ marginTop: 1 }}>
          Publié le : {new Date(creation).toLocaleDateString()} à{' '}
          {new Date(creation).toLocaleTimeString()}
        </Typography>
      )
    }
    </div>
  );
};

export default RecapArticle;